import { render, staticRenderFns } from "./FocusGuide.vue?vue&type=template&id=5977b2af&scoped=true"
import script from "./FocusGuide.vue?vue&type=script&lang=js"
export * from "./FocusGuide.vue?vue&type=script&lang=js"
import style0 from "./FocusGuide.vue?vue&type=style&index=0&id=5977b2af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5977b2af",
  null
  
)

export default component.exports